import { AiFillCloseCircle } from "react-icons/ai";
import { useAdmin } from "../../../../context/admin";
import AdminService from "../../../../services/admin.service";
import Modal from "../../../common/Modal";
import { useGlobal } from "../../../../context/global";

export default function ConfirmDeleteCashMovement() {
    const { setIsLoading } = useGlobal()
    const { confirmDeleteCashMovementId, setConfirmDeleteCashMovementId } = useAdmin()

    async function onDelete(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault()
        setIsLoading(true)
        try {
            await AdminService.deleteCashMovement(confirmDeleteCashMovementId!)
            window.location.reload()
        } catch (error) {
            console.log(error)
        } finally {
            setIsLoading(false)
        }
    }
    return (
        <Modal onSubmit={onDelete}>
            <h1>Eliminar movimiento</h1>
            <p>¿Seguro que quieres eliminar este movimiento? Esta acción no se puede deshacer.</p>
            <div className="actions" style={{ margin: '15px 0' }}>
                <button className="delete">Eliminar</button>
            </div>
            <div className="close" onClick={() => setConfirmDeleteCashMovementId(undefined)}>
                <AiFillCloseCircle />
            </div>
        </Modal>
    )
}
